import React, { FC } from 'react';

import clsx from 'clsx';

import { CheckboxFilter } from '@domains/products-catalog';

import { StyledCheckboxWithLabel } from '@components/common/StyledCheckboxWithLabel/StyledCheckboxWithLabel';

import styles from './CategoryCheckboxGroup.module.scss';

export type CategoryCheckboxGroupVariant = 'primary' | 'secondary';

export type CategoryCheckboxGroupProps = {
    data: CheckboxFilter[];
    variant?: CategoryCheckboxGroupVariant;
};

const variantToClassMap: Record<CategoryCheckboxGroupVariant, string> = {
    primary: styles.isVariantPrimary,
    secondary: styles.isVariantSecondary,
};

export const CategoryCheckboxGroup: FC<CategoryCheckboxGroupProps> = (props) => {
    const { data, variant = 'primary' } = props;

    return (
        <ul className={clsx(styles.root, variantToClassMap[variant])}>
            {data.map(({ onSelect, label, isSelected }) => (
                <li key={label} className={clsx(styles.item, variantToClassMap[variant])}>
                    <StyledCheckboxWithLabel
                        isChecked={isSelected}
                        onChange={onSelect}
                        label={label}
                    />
                </li>
            ))}
        </ul>
    );
};
